import { render, staticRenderFns } from "./PatientDetails.vue?vue&type=template&id=58456654&"
import script from "./PatientDetails.vue?vue&type=script&lang=js&"
export * from "./PatientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports